import { Supplier } from '@/models/Supplier';
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultipleModel from '@/components/CustomFilter/AbstractFilterMultipleModel';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component<SupplierFilter>({})
export default class SupplierFilter extends AbstractFilterMultipleModel implements FilterInterface {

  // #region @Props

  @Prop({ default: 'supplier' })
  protected filterStorageKey!: string;

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({
    default: () => new Supplier()
      .limit(100)
      .sort('name', 'ASC')
  })
  protected model!: Supplier;

  @Prop({ default: 'Leveranciers' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Leverancier' })
  protected placeholderSearch!: string;

  // #endregion
}
